<template>
  <div>
    <div class="preamble_box">
      <div class="preamble_item">
        <p>{{ $t('preamble.tx1') }}</p>
        <router-link to="/inputPreamble"><span class="btn Preamble_btn"> {{ $t('preamble.tx2') }}</span></router-link>
      </div>
      <div class="line"></div>
      <div class="preamble_item"
           v-show="show">
        <p>{{ $t('preamble.tx3') }}</p>
        <router-link to="/searchPreamble"><span class="btn Preamble_btn">{{ $t('preamble.tx4') }}</span></router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { preamble_code } from '@/api/login'
import { setSessionStorage, getSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      show: false,
      configData: '',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.configData = JSON.parse(getSessionStorage('message'))
      const data = JSON.parse(getSessionStorage('preambleInfo'))
      console.log('data.access_token', data.access_token, this.configData)
      if (data.access_token) {
        this.show = true
        this.getInfo(data.access_token)
      }
    },
    getInfo(token) {
      const configData = this.configData
      const access_token = token
      const msg = Object.assign(JSON.parse(JSON.stringify(configData)), {
        access_token,
      })
      preamble_code(msg).then((res) => {
        const preamblecode = res.data
        setSessionStorage('preamblecode', JSON.stringify(preamblecode))
      })
    },
    async getLang(lang) {
      const obj = await require('@/assets/lang/' + lang + '.js')
      setSessionStorage('lang1', JSON.stringify(obj.title))
    },
  },
}
</script>

<style scope lang="less">
.preamble_box {
  width: 100%;
  padding: 30/75rem;
  box-sizing: border-box;
  .preamble_item {
    font-weight: 400;
    font-size: 22/75rem;
    line-height: 33/75rem;
    color: #707070;
    position: relative;
    padding-right: 225/75rem;
    .btn {
      position: absolute;
      display: inline-block;
      width: 215/75rem;
      right: -0px;
      top: 10/75rem;
      text-align: center;
      border-radius: 30/75rem;
      border: 1px solid #ff7391;
      line-height: 50/75rem;
      font-size: 24/75rem;
      color: #ff7391;
      //   text-align: left;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background: #c7c7c7;
    margin-bottom: 30/75rem;
    margin-top: 30/75rem;
  }
}
</style>